<template>
  <Modal
    title="Convert Generic to Non-Generic Equipment"
    @hide-modal="emit('hide-modal')"
    @submit="handleSubmit"
  >
    <Select
      v-model="addressId"
      :options="options"
      label="Select Address"
      class="mb-3 address-select"
    />
    <ConvertGenericEquipmentFlow
      v-if="equipment.length"
      ref="form"
      :equipment="equipment"
    />
  </Modal>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineExpose, ref, watch } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";
import { fullAddress } from "@/mixins";
import { Address } from "@/typings/address";
import { Customer } from "@/typings/customer";
import { Equipment } from "@/typings/equipment";

const store = useStore();
const form = ref<any>(null);
defineExpose({ form });
const emit = defineEmits(["hide-modal"]);

const equipment = computed<Equipment[]>(() => store.state.customerEquipment);
const currentUser = computed<Customer | null>(() => store.state.currentUser);
const currentUserAddresses = computed<Address[] | null>(
  () => store.state.currentUserAddresses
);
const addressId = ref(null);

watch(addressId, (val, oldVal) => {
  if (val !== oldVal && val) {
    store.dispatch("fetchCustomerEquipment", {
      link: currentUser.value?.links?.fetch_equipment,
      addressId: val
    });
  }
});

const options = computed(() => {
  if (!currentUserAddresses.value) return [];
  return currentUserAddresses.value.map((address) => ({
    label: fullAddress(address),
    value: address.id
  }));
});

async function handleSubmit() {
  if (form.value) {
    try {
      const payload = await form.value.getData();
      await store.dispatch("convertGenericEquipment", {
        data: payload,
        link: payload.apiLink,
        customer: currentUser.value
      });
      window.notify.success("Equipment converted successfully!");
      emit("hide-modal");
    } catch (e) {
      // do nothing
    }
  }
}
</script>

<style lang="scss" scoped>
.address-select :deep(.select-field-label) {
  font-weight: normal !important;
}
</style>
